<template>
    <div>
        <viewer v-if="isKonfirmasi" :value="form" is-konfirmasi @koreksi="koreksi" @ok="save"></viewer>
        <b-card v-show="!isKonfirmasi" v-if="form" class="m-0" no-body>
            <b-card-header class="d-flex justify-content-between align-items-center">
                <h5 class="modal-title">{{ isEdit ? 'Edit' : 'Buat' }} Pemindahan Gudang</h5>
            </b-card-header>
            <b-card-body>
                <div class="row">
                    <div class="col-md">
                        <div class="table-responsive">
                            <table class="table">
                                <tr>
                                    <th>Kode</th>
                                    <th>Berat</th>
                                    <th>Grade</th>
                                    <th class="text-center">Aksi</th>
                                </tr>
                                <tr v-for="(item, index) in barangs">
                                    <td class="text-nowrap pl-0 fit-column">
                                        <div class="input-group mb-0 d-flex" style="width: 20rem;">
                                            <multiselect style="width:10rem; max-width: 10rem;" :class="'w-auto flex-grow-1'" v-model="barangs[index]" :options="[barangs[index]]" :placeholder="'Pilih barang'" :searchable="true"
                                                label="code" track-by="id" :allowEmpty="false" :show-labels="false"></multiselect>
                                            <div class="input-group-append">
                                                <button class="btn btn-primary mr-1" type="button" @click="findBarang(index)"><i class="fas fa-search"></i> Pilih</button>
                                                <button class="btn btn-primary" type="button" @click="findScan(index)"><i class="fas fa-qrcode"></i> Scan</button>
                                            </div>
                                        </div>
                                        <input v-show="false" v-validate="'required'" v-model="item.id" type="text" :name="'barang-'+index" class="form-control">
                                        <span class="text-danger">{{ errors.first('barang-'+index) }}</span>
                                    </td>
                                    <td class="text-nowrap pl-0 fit-column">
                                        <div v-if="item.id" class="input-group mb-0 d-flex" style="width: 10rem;">
                                            <input style="width:7rem; max-width: 7rem;" v-validate="'required'" v-model="barangs[index].latest_bobot" type="number" :name="'bobot'+index" class="form-control">
                                            <div class="input-group-append">
                                                <span class="input-group-text">KG</span>
                                            </div>
                                        </div>
                                        <div v-else>-</div>
                                        <span class="text-danger">{{ errors.first('bobot'+index) }}</span>
                                    </td>
                                    <td class="text-nowrap">
                                        {{ item.latest_grade ? item.latest_grade.name : '-' }}
                                    </td>
                                    <td class="text-center">
                                        <button v-if="barangs.length > 1" type="button" title="Delete" @click="deleteBarang(index)" class="btn btn-link text-danger px-1"><i class="fas fa-times-circle"></i></button>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="pl-0" colspan="4">
                                        <button class="btn btn-sm btn-primary" type="button" @click="addBarang"><i class="fas fa-plus"></i> Barang</button>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>

                <div class="row mt-3">
                    <div class="col-md">
                        <div class="form-group">
                            <label class="form-control-label">Gudang Asal</label>
                            <multiselect class="w-auto flex-grow-1 disabled-multiselect" name="gudang_asal" v-model="form.gudang_asal" :options="gudangOptions"
                                label="name" track-by="id" :allowEmpty="false" placeholder="" :show-labels="false"></multiselect>
                        </div>
                    </div>
                    <div class="col-md">
                        <div class="form-group">
                            <label class="form-control-label">Gudang Tujuan</label>
                            <div class="input-group mb-0 d-flex">
                                <multiselect :class="'w-auto flex-grow-1'" v-validate="'required'" name="gudang_tujuan" v-model="form.gudang_tujuan" :options="gudangOptions" :placeholder="'Pilih gudang'" :searchable="true"
                                    label="name" track-by="id" :allowEmpty="false" :show-labels="false"></multiselect>
                                <div class="input-group-append">
                                    <button class="btn btn-primary" type="button" @click="selectGudang = true"><i class="fas fa-search"></i> Pilih</button>
                                </div>
                            </div>
                            <span class="text-danger">{{ errors.first('gudang_tujuan') }}</span>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md">
                        <div class="form-group">
                            <label class="form-control-label">Tanggal Berangkat</label>
                            <div class="input-group mb-0 d-flex">
                                <date-picker class="w-auto flex-grow-1" v-model="form.tanggal_berangkat" v-validate="'required'" type="date" name="tanggal_berangkat" placeholder="Tanggal Berangkat" :editable="true" format="DD-MM-YYYY"></date-picker>
                            </div>
                            <span class="text-danger">{{ errors.first('tanggal_berangkat') }}</span>
                        </div>
                    </div>
                    <div class="col-md">
                        <div class="form-group">
                            <label>Pengirim</label>
                            <input v-validate="'required'" v-model="form.pengirim" type="text" name="pengirim" class="form-control">
                            <span class="text-danger">{{ errors.first('pengirim') }}</span>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md">
                        <div class="form-group">
                            <label>Total Biaya</label>
                            <input v-validate="'required'" v-model="form.total_biaya" type="number" name="total_biaya" class="form-control">
                            <span class="text-danger">{{ errors.first('total_biaya') }}</span>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md">
                        <div class="form-group">
                            <label>Uang Muka</label>
                            <input v-validate="'required'" v-model="form.dp" type="number" name="dp" class="form-control">
                            <span class="text-danger">{{ errors.first('dp') }}</span>
                        </div>
                    </div>
                    <div class="col-md">
                        <div class="form-group">
                            <label class="form-control-label">Metode Uang Muka</label>
                            <div class="input-group mb-0 d-flex">
                                <multiselect class='w-auto flex-grow-1' v-validate="'required'" name="metode_dp" v-model="form.metode_dp" :options="metodeOptions" :placeholder="'Pilih metode'" :searchable="true"
                                    label="value" track-by="name" :allowEmpty="false" :show-labels="false"></multiselect>
                            </div>
                            <span class="text-danger">{{ errors.first('metode_dp') }}</span>
                        </div>
                    </div>
                </div>
            </b-card-body>
            <b-card-footer class="d-flex flex-row-reverse">
                <button :disabled="isLoading" @click="$emit('cancel')" type="button" class="btn btn-secondary" data-dismiss="modal">Batal</button>
                <button :disabled="isLoading" @click="kirim(isEdit)" type="button" class="btn btn-primary mr-2">{{ isEdit ? 'Simpan' : 'Kirim' }}</button>
            </b-card-footer>
        </b-card>

        <b-modal v-model="selectGudang" size="lg" :hide-header="true" :hide-footer="true">
            <gudang-selector :selected="gudangOptions" :is-all="true" @selected="gudangSelected" @cancel="selectGudang = false"></gudang-selector>
        </b-modal>

        <b-modal v-model="selectBarang" size="lg" :hide-header="true" :hide-footer="true">
            <barang-selector one-data all-data :selected="barangs" :latest-gudang-id="form.gudang_asal ? form.gudang_asal.id : null" @selected="barangSelected" @cancel="selectBarang = false"></barang-selector>
        </b-modal>

        <b-modal v-model="scanBarang" size="md" :hide-header="true" :hide-footer="true">
            <scan-qr-code :selected="barangs" @decoded="scanned"></scan-qr-code>
		</b-modal>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import GudangSelector from '../gudangs/Selector';
import DatePicker from 'vue2-datepicker';
import BarangSelector from '../../components/BarangSelector';
import ScanQrCode from '../../components/ScanQrCode';
import Viewer from './Viewer';

export default {
    name: "pindah-gudang-form",

    props: {
        isEdit: {
            type: Boolean,
            default: false,
        },

        value: {
            type: Object,
            default: () => {},
        }
    },

    components: {
        Multiselect,
        GudangSelector,
        DatePicker,
        BarangSelector,
        ScanQrCode,
        Viewer,
    },

    data() {
        return {
            form: null,
            barangs: null,
            selectGudang: false,
            selectBarang: false,
            scanBarang: false,
            barangIndex: 0,
            gudangOptions: [],
            barangOptions: [],
            isKonfirmasi: false,
            metodeOptions: [
                {
                    name: 'tunai',
                    value: 'Tunai',
                },
                {
                    name: 'transfer',
                    value: 'Transfer',
                },
            ],
        }
    },

    created() {
        this.resetForm();
    },

    mounted() {
        if (this.value) {
            this.initForm();
        }
    },

    computed: {
    },

    watch: {
        value() {
            this.form = Object.assign({}, this.value);
        }
    },

    methods: {
        resetForm() {
            this.form = Object.assign({}, {
                gudang_asal: null,
                gudang_tujuan: null,
                tanggal_berangkat: null,
                pengirim: null,
                total_biaya: null,
                dp: null,
                metode_dp: null,
            });
            this.form.gudang_tujuan = Object.assign({}, this.userGudang);

            this.barangs = Object.assign([], [
                {
                    bobot: null,
                    grade: null,
                },
            ]);
        },

        initForm() {
            let self = this;

            self.form = Object.assign({}, self.value);
            if (!self.isEdit) {
                self.form.gudang_tujuan = Object.assign({}, self.form.latest_pindah_gudang);
            } else {
                let metodeDpIndex = self.metodeOptions.findIndex(option => option.name == self.form.metode_dp);
                self.form.metode_dp = Object.assign({}, self.metodeOptions[metodeDpIndex]);
                self.form.tanggal_berangkat = new Date(self.formatDate(self.form.tanggal_berangkat, 'YYYY-MM-DD'));
                self.barangs = [];
                self.form.kemasans.forEach(kemasan => {
                    self.barangs.push(Object.assign({}, {
                        id: kemasan.pembelian_tembakau.id,
                        code: kemasan.pembelian_tembakau.code,
                        latest_bobot: kemasan.bobot_berangkat,
                        latest_grade: kemasan.grade_berangkat ? Object.assign({}, kemasan.grade_berangkat) : null,
                    }));
                });
            }
        },

        kirim(isSave = false) {
            let self = this;

            self.$validator.validateAll().then(result => {
                if (result) {
                    if (isSave) {
                        self.save();
                    } else {
                        self.form.barangs = Object.assign([], self.barangs);
                        self.isKonfirmasi = true;
                    }
                }
            });
        },

        koreksi() {
            this.isKonfirmasi = false;
        },

        save() {
            let self = this;

            self.isLoading = true;

            let data = {
                gudang_asal_id: self.form.gudang_asal ? self.form.gudang_asal.id : null,
                gudang_tujuan_id: self.form.gudang_tujuan ? self.form.gudang_tujuan.id : null,
                tanggal_berangkat: self.convertUserTimezone(self.form.tanggal_berangkat),
                pengirim: self.form.pengirim,
                total_biaya: self.form.total_biaya,
                dp: self.form.dp,
                metode_dp: self.form.metode_dp ? self.form.metode_dp.name : null,
                pembelian_tembakau_ids: self.barangs.map(barang => barang.id),
                pembelian_tembakau_bobots: self.barangs.map(barang => barang.latest_bobot),
            }

            let api = self.isEdit ? '/api/pindah-gudangs/'+self.form.id : '/api/pindah-gudangs';

            self.$Progress.start();
            axios({
                method: self.isEdit ? 'put' : 'post',
                url: api,
                data: data
            })
            .then(function (response) {
                Toast.fire({
                    icon: 'success',
                    title: response.data.message
                });
                self.$Progress.finish();
                self.isLoading = false;
                self.$emit('saved', response.data.data);
            })
            .catch(function (error) {
                self.requestFailed(error);
            });
        },

        gudangSelected(gudang) {
            let self = this;

            self.gudangOptions.push(gudang);
            self.form.gudang_tujuan = Object.assign({}, gudang);
            self.selectGudang = false;
        },

        addBarang() {
            this.barangs.push(Object.assign({}, {
                id: null,
                code: null,
                bobot: null,
                grade: null,
            }));
        },

        deleteBarang(index) {
            this.barangs.splice(index, 1);
        },

        findBarang(index) {
            this.barangIndex = index;
            this.selectBarang = true;
        },

        findScan(index) {
            this.barangIndex = index;
            this.scanBarang = true;
        },

        barangSelected(barang) {
            let self = this;

            let index = self.barangOptions.findIndex(b => b.code == barang.code);
            if (index > -1) {
                self.barangs[self.barangIndex] = Object.assign({}, self.barangOptions[index]);
            } else {
                self.barangs[self.barangIndex] = Object.assign({}, barang);
                self.barangOptions.push(barang);
            }
            self.form.gudang_asal = Object.assign({}, barang.latest_gudang);
            self.selectBarang = false;
        },

        scanned(value) {
            let self = this;

            let index = self.barangOptions.findIndex(barang => barang.code == value);
            if (index > -1) {
                self.barangs[self.barangIndex] = Object.assign({}, self.barangOptions[index]);
            } else {
                self.getBarang(value);
            }
            self.scanBarang = false;
        },

        getBarang(code) {
            let self = this;

            self.$Progress.start();
            axios({
                method: 'get',
                url: '/api/pembelian-tembakaus?is_pilih=1&search='+code+'&all_data=1&latest_gudang_id='+(self.form.gudang_asal ? self.form.gudang_asal.id : ''),
            })
            .then(function (response) {
                Toast.fire({
                    icon: 'success',
                    title: response.data.message
                });
                self.$Progress.finish();
                if (response.data.data.length) {
                    let data = Object.assign({}, response.data.data[0]);
                    self.barangOptions.push(data);
                    self.barangs[self.barangIndex] = Object.assign({}, data);
                    self.form.gudang_asal = Object.assign({}, data.latest_gudang);
                } else {
                    Toast.fire({
                        icon: 'warning',
                        title: 'Kode ' + code + ' tidak ditemukan.'
                    });
                }
            })
            .catch(function (error) {
                self.requestFailed(error);
            });
        },
    },
}
</script>
<style>
.multiselect__placeholder {
    margin-bottom: 0;
}

.disabled-multiselect {
    pointer-events: none;
}

.disabled-multiselect > .multiselect__tags {
    border-top-right-radius: 5px !important;
    border-bottom-right-radius: 5px !important;
}

.fit-column {
    width: 0.1%;
    white-space: nowrap;
}
</style>
